import React, { useEffect, useState } from "react";
import styles from "./purchases.module.css";
import { Doughnut } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import GridUI from "@material-ui/core/Grid";
import Backdrop from "../../Backdrop";
import { Grid, Table, TableBandHeader, TableHeaderRow } from '@devexpress/dx-react-grid-material-ui';
import { withStyles } from '@material-ui/core/styles';
import util from "../../../Js/util.js";
import { useTranslation } from 'react-i18next';

// Total amount of providers table
let totalAmountProviders = 0;
let totalOverdueBills = 0;
var currencyCliente = "";
var currencyInvoice = "";

const tableStyles = {
    tableStriped: {
        '& tbody tr:nth-of-type(odd)': {
            backgroundColor: '#faf8fe',
        },
    },
    tableHeader: {
        border: 'none',
        backgroundColor: '#e4def9',
        fontSize: '15px',
        fontWeight: 600,
        color: '#131f3e',
        '&:first-child': {
            borderRadius: '10px 0 0 0',
        },
        '&:last-child': {
            borderRadius: '0 10px 0 0',
        }
    },
    tableHeaderBand: {
        border: 'none',
        backgroundColor: '#FFFFFF',
        fontSize: '16px',
        fontWeight: 600,
        color: '#4a22d4',
    },
    tableBody: {
        border: 'none',
        fontSize: '14px',
        fontWeight: 400,
        color: '#131f3e',
    },
};

const tableBandCellBase = ({ classes, ...props }) => (
    <TableBandHeader.Cell
        {...props}
        className={classes.tableHeaderBand}
    />
);

const tableHeaderCellBase = ({ classes, ...props }) => (
    <TableHeaderRow.Cell
        {...props}
        className={classes.tableHeader}
    />
);

const TableComponentBase = ({ classes, ...props }) => (
    <Table.Table
        {...props}
        className={classes.tableStriped}
    />
);

const TableCellComponentBase = ({ classes, ...props }) => (
    <Table.Cell
        {...props}
        className={classes.tableBody}
    />
);

const tableContentComponent = props => (
    <TableHeaderRow.Content {...props} align={'center'} />
);

const tableBandCell = withStyles(tableStyles, { name: 'tableBandCell' })(tableBandCellBase);
const tableHeaderCell = withStyles(tableStyles, { name: 'tableHeaderCell' })(tableHeaderCellBase);
const TableComponent = withStyles(tableStyles, { name: 'TableComponent' })(TableComponentBase);
const TableCellComponent = withStyles(tableStyles, { name: 'TableCellComponent' })(TableCellComponentBase);

const Purchases = (props) => {
    // Component state
    const [t] = useTranslation("global");
    // Number format for charts tooltip
    let numberFormat = new Intl.NumberFormat(t("language.currencyFormat"));

    const [showBackdrop, setshowBackdrop] = useState(false);
    const [overdueBill, setOverdueBill] = useState({
        rowData: [],
        charts: {
            plugins: [ChartDataLabels],
            data: {},
        },
    });

    const [mainProviders, setmainProviders] = useState({
        rowData: [],
        charts: {
            plugins: [ChartDataLabels],
            data: {},
        },
    });

    const chartOptionsBill = {
        tooltips: {
            callbacks: {
                label: (tooltipItem, data) => {
                    let label = ` ${data.labels[tooltipItem.index]}` || '';

                    if (label) {
                        label += ': ';
                    }

                    label += numberFormat.format(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toFixed(2));

                    return label;
                }
            },
            backgroundColor: 'rgba(19, 31, 62, 0.80)',
        },
        maintainAspectRatio: false,
        plugins: {
            datalabels: {
                color: "#131f3e",
                font: {
                    family: "'Goldplay',sans-serif",
                    weight: "600",
                },
                formatter: function (value) {
                    const partPercentage = parseInt(
                        (value * 100) / totalOverdueBills
                    );
                    return `${partPercentage}%`;
                },
            },
        },
        legend: {
            display: true,
            labels: {
                fontColor: "#131f3e",
                fontFamily: "'Goldplay',sans-serif",
                boxWidth: 10,
                fontSize: 10,
                padding: 15
            },
            position: "bottom",
        },
    };

    const chartOptionsProviders = {
        tooltips: {
            callbacks: {
                label: (tooltipItem, data) => {
                    let label = ` ${data.labels[tooltipItem.index]}` || '';

                    if (label) {
                        label += ': ';
                    }

                    label += numberFormat.format(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toFixed(2));

                    return label;
                }
            },
            backgroundColor: 'rgba(19, 31, 62, 0.80)',
        },
        maintainAspectRatio: false,
        plugins: {
            datalabels: {
                color: "#131f3e",
                font: {
                    family: "'Goldplay',sans-serif",
                    weight: "600",
                },
                formatter: function (value) {
                    const partPercentage = parseInt(
                        (value * 100) / totalAmountProviders
                    );
                    return `${partPercentage}%`;
                },
            },
        },
        legend: {
            display: true,
            labels: {
                fontColor: "#131f3e",
                fontFamily: "'Goldplay',sans-serif",
                boxWidth: 10,
                fontSize: 10,
                padding: 15
            },
            position: "bottom"
        },
    };

    const tableMessages = {
        noData: t("miscellaneous.noData")
    };

    // Component Did Mount event
    useEffect(() => {
        (async () => {
            // This component presents information ONLY for Organization dashboard
            if (props.orgIdSelected) {
                // ----------------------------------------------------
                setshowBackdrop(true);
                /**  Requesting data first */

                // Setting overdue invoice data
                const billDataResult = await fetch(
                    `/getOverdueBills?id_organisation=${props.orgIdSelected}`,
                    {
                        method: "GET",
                        headers: {
                            "Content-type": "application/json; charset=UTF-8",
                            "Access-Control-Allow-Origin": "*",
                        },
                    }
                ).then((res) => res.json()
                ).then((data) => {
                    return Promise.resolve(data);
                });

                // Setting main providers data
                const providersDataResult = await fetch(
                    `/getSuppliersYouOwe?id_organisation=${props.orgIdSelected}`,
                    {
                        method: "GET",
                        headers: {
                            "Content-type": "application/json; charset=UTF-8",
                            "Access-Control-Allow-Origin": "*",
                        },
                    }
                ).then((res) => res.json()
                ).then((data) => {
                    return Promise.resolve(data);
                });

                // ----------------------------------------------------
                //Providers

                currencyCliente = providersDataResult.baseCurrency;

                var mainProvidersData = providersDataResult.arrayInvoices.map((item) => {
                    return {
                        CurrencyCodeVef: providersDataResult.baseCurrency,
                        behind: item.ContactName,
                        [providersDataResult.baseCurrency]: parseFloat(item.AmountDue).toLocaleString(t("language.currencyFormat"), { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        AmountDue: parseFloat(item.AmountDue),
                    }
                });

                // Getting total amount from all providers
                totalAmountProviders = mainProvidersData.reduce(
                    (total, provider) => {
                        return total + provider.AmountDue
                    },
                    0
                );

                // Setting values for providers chart
                var providersChartData = mainProvidersData.map(
                    (provider) => {
                        return provider.AmountDue;
                    }
                );

                // Setting labels for providers chart
                var providersChartLabels = mainProvidersData.map(
                    (provider) => {
                        return provider.behind.substring(0, 10) + "..";
                    });


                // ----------------------------------------------------
                //Bills

                currencyInvoice = billDataResult.baseCurrency;

                var overdueBillsData = billDataResult.arrayInvoices.map((item) => {
                    let label = "";
                        switch (item.MonthsDue) {
                            case "Vigentes":
                                label = t("dashboardGroup.current");
                                break;
                            case "1 mes":
                                label = "1 " + t("dashboardGroup.month");
                                break;
                            case "3 meses":
                                label = "3 " + t("dashboardGroup.months");
                                break;
                            case "+3 meses":
                                label = "+3 " + t("dashboardGroup.months");
                                break;
                            default:
                                break;
                        }
                    return {
                        CurrencyCodeVef: billDataResult.baseCurrency,
                        behind: label,
                        [billDataResult.baseCurrency]: parseFloat(item.AmountDue).toLocaleString(t("language.currencyFormat"), { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        AmountDue: item.AmountDue,
                    };
                });

                // Getting total amount from all overdue bill
                totalOverdueBills = overdueBillsData.reduce(
                    (total, bill) => {
                        return total + bill.AmountDue;
                    },
                    0
                );

                // Setting values for overdue bill chart
                var overdueBillsChartData = overdueBillsData.map(
                    (bill) => {
                        return bill.AmountDue;
                    }
                );

                // Setting labels for overdue bill chart
                var overdueBillsChartLabels = overdueBillsData.map(
                    (bill) => {
                        return bill.behind;
                    }
                );

                // Updating overdueBill state
                setOverdueBill(prevOverdueBill => ({
                    ...prevOverdueBill,
                    rowData: overdueBillsData,
                    charts: {
                        data: {
                            datasets: [
                                {
                                    data: overdueBillsChartData,
                                    backgroundColor: [
                                        "#fedbb6",
                                        "#f7b5d2",
                                        "#8ad3df",
                                        "#9ed4b0",
                                        "rgba(74, 34, 212, 0.6)",
                                    ],
                                },
                            ],
                            labels: overdueBillsChartLabels,
                        },
                    },
                }));

                // Updating mainProviders state
                setmainProviders(prevmainProviders => ({
                    ...prevmainProviders,
                    rowData: mainProvidersData,
                    charts: {
                        data: {
                            datasets: [
                                {
                                    data: providersChartData,
                                    backgroundColor: [
                                        "#fedbb6",
                                        "#f7b5d2",
                                        "#8ad3df",
                                        "#9ed4b0",
                                        "rgba(74, 34, 212, 0.6)",
                                    ],
                                },
                            ],
                            labels: providersChartLabels,
                        },
                    },
                }));

                setshowBackdrop(false);
            }
        })();
    }, [props.orgIdSelected, t]);

    // ----------------------------------------------------

    // Component rendering
    return (
        <>
            <GridUI
                container
                direction="row"
            >
                <GridUI item xs={12} lg={3} className={styles.SalesTable}>
                    <Grid
                        rows={overdueBill.rowData}
                        columns={util.returnHeaderInvoice(currencyInvoice, t("dashboardGroup.antiquity"))}
                    >
                        <Table
                            tableComponent={TableComponent}
                            messages={tableMessages}
                            cellComponent={TableCellComponent}
                            columnExtensions={util.returnHeaderExtension(currencyInvoice)}
                        />
                        <TableHeaderRow
                            cellComponent={tableHeaderCell}
                            contentComponent={tableContentComponent}
                        />
                        <TableBandHeader
                            cellComponent={tableBandCell}
                            columnBands={util.returnHeaderInvoiceBand(currencyInvoice, t("dashboardGroup.billstopay"))}
                        />
                    </Grid>
                </GridUI>
                <GridUI item xs={12} lg={3} className={styles.SalesChart}>
                    <div className={styles.ChartTitle}>{t("dashboardGroup.antiquity")}</div>
                    <div className={styles.ChartContainer}>
                        {totalOverdueBills === 0 ?
                            <div style={{ textAlign: "center", zIndex: "9999", fontSize: "9pt" }} >{t("miscellaneous.noData")}</div>
                            :
                            null
                        }
                        <Doughnut
                            data={overdueBill.charts.data}
                            options={chartOptionsBill}
                        />
                    </div>
                </GridUI>
                {props.dashboardType !== "group" ? (
                    <GridUI item xs={12} lg={6}>
                        <GridUI
                            container
                            direction="row"
                        >
                            <GridUI item xs={12} lg={6} className={styles.SalesTable2}>
                                <Grid
                                    rows={mainProviders.rowData}
                                    columns={util.returnHeaderInvoice(currencyCliente, t("miscellaneous.supplier"))}
                                >
                                    <Table
                                        tableComponent={TableComponent}
                                        messages={tableMessages}
                                        cellComponent={TableCellComponent}
                                        columnExtensions={util.returnHeaderExtension(currencyCliente)}
                                    />
                                    <TableHeaderRow
                                        cellComponent={tableHeaderCell}
                                        contentComponent={tableContentComponent}
                                    />
                                    <TableBandHeader
                                        cellComponent={tableBandCell}
                                        columnBands={util.returnHeaderInvoiceBand(currencyCliente, t("dashboardGroup.mainSuppliers"))}
                                    />
                                </Grid>
                            </GridUI>
                            <GridUI item xs={12} lg={6} className={styles.SalesChart}>
                                <div className={styles.ChartTitle}>
                                    {t("dashboardGroup.mainSuppliers")}
							        </div>
                                <div className={styles.ChartContainer}>
                                    {totalAmountProviders === 0 ?
                                        <div style={{ textAlign: "center", zIndex: "9999", fontSize: "9pt" }} >{t("miscellaneous.noData")}</div>
                                        :
                                        null
                                    }
                                    <Doughnut
                                        data={mainProviders.charts.data}
                                        options={chartOptionsProviders}
                                    />
                                </div>
                            </GridUI>
                        </GridUI>
                    </GridUI>
                ) : null}
            </GridUI>
            <Backdrop
                open={showBackdrop}
            />
        </>
    );
}

export default Purchases;
